import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { anyDisabledSchedule, userCanEditSchedule } from '../../app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleEnable } from './ScheduleMenuActions';

export const ScheduleEnableAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.EnableSchedules,
  translateName: Messages.enable_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return anyDisabledSchedule(targetItems);
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleEnable(targetItems)
};
